<template>
	<div id="newsCoreRead">
		<div class="menu">
			<router-link to="/newsCore">
				<span class="newsCoreTitle unRead">未读消息</span>
			</router-link>
			<router-link to="/newsCoreRead">
				<span class="newsCoreTitle">已读消息</span>
			</router-link>
		</div>
		<ul>
			<div v-for="item in coreData">
				<!-- <router-link :to="{name:'newsCoreDetail',query:{id:item.id}}"> -->
				<!-- <router-link :to="item.url"> -->
				<a :href="item.url">
					<li>
						<div>
							<b v-html="item.title"></b>
						</div>
						<span v-html="item.content"></span>
					</li>
				</a>
				<!-- </router-link> -->
			</div>
		</ul>
		<infinite-loading @infinite="onInfinite" distace="10" ref="infiniteLoading">
			<span slot="no-more">
				全部数据已加载完
			</span>
		</infinite-loading>
	</div>

</template>
<script>
	import {
		getListRead
	} from '@/api/message.js'
	import InfiniteLoading from "vue-infinite-loading";
	import {
		Indicator
	} from "mint-ui";
	export default {
		components: {
			InfiniteLoading
		},
		data() {
			//由于是组件，data必须是个函数，这是ES6写法，data后面加括号相当于data: function () {}
			return {
				//记得return不然接收不到数据
				coreData: [],
				pageNumber: 0,
				pageSize: 10,
				totalElements: 0
			};
		},
		methods: {
			// 获取已读信息
			getRead(pageNumber) {
				let that = this
				Indicator.open({
					//加载提示
					text: "加载中...",
					spinnerType: "fading-circle"
				});
				getListRead(pageNumber, this.pageSize).then(res => {
					that.coreData = this.coreData.concat(res.data.content)
					Indicator.close();
					that.totalElements = res.data.totalElements
					that.$refs.infiniteLoading.$emit("$InfiniteLoading:loaded")
					if (that.totalElements == that.coreData.length) {
						that.$refs.infiniteLoading.$emit("$InfiniteLoading:complete")
					}
				})

			},
			// 上拉加载
			onInfinite() {
				this.pageNumber += 1
				this.getRead(this.pageNumber)
			}
		},
		mounted() {
			this.getRead(0);
		}

	};
</script>
<style>
	#newsCoreRead {
		text-align: left;
		margin: 0 auto;
		max-width: 500px;
		overflow: hidden;
	}

	#newsCoreRead .newsCoreTitle {
		padding-left: 15px;
		line-height: 24px;
		color: #42b983;
	}

	.menu .unRead {
		color: #333333 !important;
	}

	#newsCoreRead ul li {
		width: calc(100% - 50px);
		background-color: #ffffff;
		margin: 12px 15px;
		padding: 11px 10px;
		position: relative;
	}

	#newsCoreRead ul li span {
		color: #999;
		margin-top: 5px;
		display: block;
	}

	#newsCoreRead ul li:hover {
		background-color: #fcfcfc;
	}

	#newsCoreRead ul li::after {
		content: " ";
		display: inline-block;
		height: 8px;
		width: 8px;
		border-width: 2px 2px 0 0;
		border-color: #b2b2b2;
		border-style: solid;
		-webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position: relative;
		top: -2px;
		position: absolute;
		top: 50%;
		margin-top: -5px;
		right: 12px;
	}
</style>
